import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getArticleGroupDiscountById } from "../../app/services/articleGroupDiscountService";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Form from "react-bootstrap/Form";
import {  
  Breadcrumb,
  Button,
  Col,  
  Row
} from "react-bootstrap";
import moment from "moment";

interface Props {}

const ArticleGroupDiscountView: FC<Props> = () => {
  moment.locale("sv");
  const { articleGroupDiscountId } = useParams<{
    articleGroupDiscountId: string;
  }>();
  const dispatch = useAppDispatch();

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const articleGroupDiscountData = useSelector(
    (state: RootState) => state.articleGroupDiscount,
  );

  useEffect(() => {
    dispatch(
      getArticleGroupDiscountById(instance, account, articleGroupDiscountId),
    );
  }, [account, accounts, dispatch, instance, articleGroupDiscountId]);

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="/article-group-discounts">
          Artikelgruppsrabatter
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{articleGroupDiscountId}</Breadcrumb.Item>
      </Breadcrumb>
      <hr />
      <Form>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Namn</Form.Label>
              <Form.Control
                type="text"
                value={articleGroupDiscountData.articleGroupDiscount.name}
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Beskrivning</Form.Label>
              <Form.Control
                type="text"
                value={
                  articleGroupDiscountData.articleGroupDiscount.description
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Rabatt %</Form.Label>
              <Form.Control
                type="text"
                value={
                  articleGroupDiscountData.articleGroupDiscount
                    .discountPercentage
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Artikelgrupp</Form.Label>
              <Form.Control
                type="text"
                value={
                  articleGroupDiscountData.articleGroupDiscount.externalGroupId
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Skapad</Form.Label>
              <Form.Control
                type="date"
                value={
                  articleGroupDiscountData.articleGroupDiscount.createdAt
                  ? new Date(articleGroupDiscountData.articleGroupDiscount.createdAt).toLocaleDateString()
                  : "-"
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Uppdaterad</Form.Label>
              <Form.Control
                type="date"
                value={
                  articleGroupDiscountData.articleGroupDiscount.updatedAt
                    ? new Date(articleGroupDiscountData.articleGroupDiscount.updatedAt).toLocaleDateString()
                    : "-"
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>

      <Row>
        <div className="text-end">
          <Button
            variant="primary"
            href={`/article-group-discounts/${articleGroupDiscountId}/edit`}
          >
            Redigera
          </Button>
        </div>
      </Row>
    </div>
  );
};

export default ArticleGroupDiscountView;
